import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BarChart3 } from "lucide-react";

const RANGES = [[7, "7 days"], [30, "30 days"], [90, "90 days"], [0, "All time"]];

export function SignupSources() {
  const [days, setDays] = useState(30);
  const [rows, setRows] = useState(null);
  useEffect(() => { setRows(null); api.get(`/admin/marketing/sources?days=${days}`).then(({ data }) => setRows(data)); }, [days]);
  const total = (rows || []).reduce((n, r) => n + r.signups, 0);
  return (
    <div data-testid="signup-sources" className="rounded-2xl border border-white/8 bg-surface p-5 space-y-4">
      <div className="flex flex-wrap items-center gap-3">
        <p className="text-sm flex items-center gap-2"><BarChart3 size={14} className="text-gold" /> Sign-ups by ad source</p>
        <div className="ml-auto flex gap-1">
          {RANGES.map(([d, l]) => (
            <button key={d} data-testid={`sources-range-${d}`} onClick={() => setDays(d)}
              className={`px-3 py-1 rounded-full text-[10px] uppercase tracking-[0.15em] ${days === d ? "bg-gold/15 text-gold" : "text-text-muted"}`}>{l}</button>
          ))}
        </div>
      </div>
      {!rows ? <p className="text-text-muted text-sm">Loading…</p> : !rows.length ? <p className="text-text-muted text-sm">No sign-ups in this period.</p> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-[10px] uppercase tracking-[0.15em] text-text-muted text-left">
              <th className="py-2">Source</th><th>Campaign</th><th className="text-right">Sign-ups</th><th className="text-right">ID verified</th><th className="text-right">Paying</th><th className="text-right">Share</th>
            </tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={`${r.source}-${r.campaign}`} data-testid={`source-row-${r.source}`} className="border-t border-white/5">
                  <td className="py-2.5 capitalize">{r.source}</td><td className="text-text-muted">{r.campaign || "—"}</td>
                  <td className="text-right">{r.signups}</td><td className="text-right">{r.verified}</td><td className="text-right">{r.paying}</td>
                  <td className="text-right text-gold">{total ? Math.round((r.signups / total) * 100) : 0}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
